import { connect } from 'react-redux';

import { selectors } from '../../dux/user';
import OrganizationPage from './OrganizationPage';

const mapStateToProps = (state) => ({
  accessToken: selectors.getCredentialsState(state).accessToken,
});

export default connect(mapStateToProps, {})(OrganizationPage);
